<template>
  <div class="nolist-box">
      <img src="~@/assets/e_commerce_request_error_icon.png"/>
      <p>{{text||'暂无数据'}}</p>
  </div>
</template>

<script>
export default {
    props:[
        'text'
    ]
}
</script>

<style lang="scss" scoped>
.nolist-box{
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img{
        width: 200px;
    }

    p{
        margin-top: 10px;
        font-size: 24px;
        color: #1f623f;
    }

}
</style>